import { Check, X } from "lucide-react";

const COMMON = new Set([
  "password1", "password12", "password123", "password2024", "password2025", "password2026", "passw0rd", "passw0rd1",
  "qwerty123", "qwerty1234", "qwertyuiop1", "abc12345", "abcd1234", "abcdef12", "a1234567", "aa123456",
  "12345678a", "123456789a", "1234567890a", "iloveyou1", "welcome1", "welcome123", "benvenuto1", "ciao1234",
  "ciaociao1", "amore123", "amoremio1", "juventus1", "juventus1897", "napoli1926", "milan1899", "inter1908",
  "roma1927", "forzajuve1", "forzanapoli1", "forzamilan1", "forzainter1", "forzaroma1", "italia123", "italia2026",
  "readoo2026", "readoo123", "readoo1", "deltapictures1", "admin123", "admin1234", "changeme1", "letmein1",
  "dragon123", "monkey123", "sunshine1", "princess1", "football1", "superman1", "batman123", "starwars1",
]);

export const PASSWORD_RULES = [
  { key: "len", label: "Almeno 8 caratteri", test: (p) => p.length >= 8 },
  { key: "upper", label: "Una lettera maiuscola", test: (p) => /[A-Z]/.test(p) },
  { key: "lower", label: "Una lettera minuscola", test: (p) => /[a-z]/.test(p) },
  { key: "digit", label: "Un numero", test: (p) => /\d/.test(p) },
];

export const isCommonPassword = (p = "") => COMMON.has(p.toLowerCase());
export const passwordValid = (p = "") => PASSWORD_RULES.every((r) => r.test(p)) && p.length <= 128 && !isCommonPassword(p);

export function PasswordChecklist({ value = "", testid = "password-checklist" }) {
  const common = value && PASSWORD_RULES.every((r) => r.test(value)) && isCommonPassword(value);
  return (
    <div data-testid={testid} className="text-[11px] leading-snug">
      <ul className="grid grid-cols-2 gap-x-3 gap-y-1">
        {PASSWORD_RULES.map((r) => {
          const ok = r.test(value);
          return (
            <li key={r.key} data-testid={`${testid}-${r.key}`} data-ok={ok} className={`flex items-center gap-1 transition-colors ${ok ? "text-emerald-500" : "text-subtle"}`}>
              {ok ? <Check size={12} strokeWidth={3} /> : <X size={12} />} {r.label}
            </li>
          );
        })}
      </ul>
      {common && <p data-testid={`${testid}-common`} className="mt-1 text-bad">Password troppo comune, scegline un'altra.</p>}
    </div>
  );
}
